import axios from 'axios'
import toast from 'react-hot-toast'

// Configuration de base d'Axios
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Intercepteur de requête
api.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification si disponible
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercepteur de réponse
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { response } = error

    if (response) {
      const { status, data } = response

      switch (status) {
        case 401:
          // Token expiré ou invalide
          if (data.message?.includes('expiré') || data.message?.includes('invalide')) {
            localStorage.removeItem('token')
            delete api.defaults.headers.common['Authorization']

            // Redirection vers la page de connexion
            if (window.location.pathname !== '/login') {
              window.location.href = '/login'
              toast.error('Session expirée, veuillez vous reconnecter')
            }
          }
          break

        case 403:
          toast.error('Accès non autorisé')
          break

        case 404:
          toast.error('Ressource non trouvée')
          break

        case 422:
          // Erreurs de validation
          if (data.details && Array.isArray(data.details)) {
            data.details.forEach(detail => {
              toast.error(`${detail.param}: ${detail.msg}`)
            })
          } else {
            toast.error(data.message || 'Données invalides')
          }
          break

        case 429:
          toast.error('Trop de requêtes, veuillez patienter')
          break

        case 500:
          toast.error('Erreur serveur, veuillez réessayer plus tard')
          break

        default:
          toast.error(data.message || 'Une erreur est survenue')
      }

      // Retourner l'erreur avec le message du serveur
      return Promise.reject(new Error(data.message || 'Une erreur est survenue'))
    }

    // Erreur réseau ou timeout
    if (error.code === 'ECONNABORTED') {
      toast.error('Délai d\'attente dépassé')
    } else if (error.message === 'Network Error') {
      toast.error('Erreur de connexion')
    } else {
      toast.error('Une erreur est survenue')
    }

    return Promise.reject(error)
  }
)

export default api